import type {Transition, Variants} from 'framer-motion';

export const POSTER_MOBILE_TIMELINE_HEIGHT_RATIO = 0.5;
export const MOBILE_TIMELINE_MIN_HEIGHT = 110;
export const MOBILE_TIMELINE_MAX_HEIGHT = 800;
export const MOBILE_TIMELINE_DEFAULT_HEIGHT = 220;
/** The whiteboard keeps at least this much of the editor area; the timeline may not grow (or restore from a taller viewport) past it. */
export const MOBILE_TIMELINE_MIN_WHITEBOARD_HEIGHT = 200;

/** Mirrors the desktop bottom bar: the panel grows from the bottom bar upward while the canvas above gives way. */
export const MOBILE_TIMELINE_PANEL_TRANSITION: Transition = {duration: 0.3, ease: [0.4, 0, 0.2, 1]};
export const MOBILE_TIMELINE_PANEL_CONTENT_TRANSITION: Transition = {duration: 0.2};

export const MOBILE_TIMELINE_PANEL_CONTENT_VARIANTS: Variants = {
  hidden: {opacity: 0},
  shown: {opacity: 1},
};
